export default __webpack_public_path__ + "static/media/Leggings of the Harbinger.a7593cd9.jpg";